import { Button } from '@talentmesh/ui/components/button';
import { cn } from '@talentmesh/ui/lib/utils';
import { generatePath, useNavigate } from 'react-router';
import AiSparklesIcon from '@/Components/TalentMeshIcons/AiSparklesIcon';
import useClientIdPathParam from '@/Hooks/UseClientIdPathParam';
import useCompanyId from '@/Hooks/UseCompanyId';
import RoutePath from '@/Routing/RoutePath';
import UIStrings from '@/Utils/UIStrings';

interface CreateRecruitmentButtonProps {
    hidden?: boolean;
}

const CreateRecruitmentButton = ({ hidden }: CreateRecruitmentButtonProps) => {
    const navigate = useNavigate();
    const companyId = useCompanyId();
    const clientId = useClientIdPathParam();

    const handleAssessmentCreateClick = () => {
        const createRecruitmentPath = generatePath(RoutePath.CreateAssessment, { companyId, clientId });
        navigate(createRecruitmentPath);
    };

    return (
        <Button
            type="button"
            onClick={handleAssessmentCreateClick}
            className={cn(hidden && 'pointer-events-none invisible')}
        >
            <AiSparklesIcon />
            {UIStrings.CreateRecruitment}
        </Button>
    );
};

export default CreateRecruitmentButton;
